import Vue from 'vue'

import { addCustomWidgetSchema } from '@/components/form-designer/widget-panel/widgetsConfig'
// 注册属性设置组件
import * as PERegister from '@/components/form-designer/setting-panel/propertyRegister'
// 生成组件属性设置
import * as PEFactory from '@/components/form-designer/setting-panel/property-editor-factory'

import datetimePicker from "@/extension/h5/datetime-picker"

addCustomWidgetSchema({
  type: 'datetimePicker',
  icon: 'alert',
  formItemFlag: true,
  options: {
    name: '',
    label: '出生日期',
    columnWidth: '200px',
    labelWidth: '110',
    labelAlign: 'label-right-align',
    title: '出生日期',
    textAlign: "left",//文字对齐方式
    disabled:false,
    //-------------------
    customClass: '',  //自定义css类名
    placeholder: '',
    labelHidden: true,
    required: false,
    requiredHint: '',
    //-------------------
    onCreated: '',
    onMounted: '',
    onChange: '',
  }
})  //加载组件Json Schema

Vue.component(datetimePicker.name, datetimePicker)  //注册组件

